import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { partial } from '../../../../util/translation/translation';
import { formatDayTime } from '../seriesUtils';

// Cancelling one date: everyone booked and on the waitlist is told by push
// and/or email (at least one), with an optional message from the admin
const CancelOccurrenceModal = ({ occurrence, onClose, onConfirm, busy }) => {
  const p = partial('EventSeries');
  const [push, setPush] = useState(true);
  const [email, setEmail] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (occurrence) {
      setPush(true);
      setEmail(true);
      setMessage('');
    }
  }, [occurrence]);

  const channels = [push && 'push', email && 'email'].filter(Boolean);
  const affected = occurrence
    ? (occurrence.participantCount || 0) + (occurrence.waitingCount || 0)
    : 0;

  return (
    <Modal isOpen={!!occurrence} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{p('cancelOccurrenceTitle')}</ModalHeader>
      {occurrence && (
        <ModalBody>
          <p className="mb-2">
            <strong>{formatDayTime(occurrence.startDate)}</strong>
          </p>
          <p className="text-muted mb-3" style={{ fontSize: 13 }}>
            {affected > 0
              ? p('cancelNotifies', { count: affected })
              : p('cancelNobodyBooked')}
          </p>
          <span className="form-header d-block mb-1">{p('notifyBy')}</span>
          <div className="d-flex mb-3" style={{ gap: 24 }}>
            <Label check className="ml-4">
              <Input
                type="checkbox"
                checked={push}
                onChange={(event) => setPush(event.target.checked)}
              />
              {p('channelPush')}
            </Label>
            <Label check className="ml-4">
              <Input
                type="checkbox"
                checked={email}
                onChange={(event) => setEmail(event.target.checked)}
              />
              {p('channelEmail')}
            </Label>
          </div>
          {!channels.length && (
            <span className="form__form-group-error d-block mb-2">
              {p('channelRequired')}
            </span>
          )}
          <label
            className="form-header d-block mb-1"
            htmlFor="cancelOccurrenceMessage"
          >
            {p('cancelMessage')}
          </label>
          <Input
            id="cancelOccurrenceMessage"
            type="textarea"
            rows={3}
            value={message}
            placeholder={p('cancelMessagePlaceholder')}
            onChange={(event) => setMessage(event.target.value)}
          />
        </ModalBody>
      )}
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={onClose}>
          {p('keepOccurrence')}
        </Button>
        <Button
          color="danger"
          className="mb-0"
          disabled={!channels.length || busy}
          onClick={() => onConfirm({ channels, message: message.trim() })}
        >
          {p('cancelOccurrence')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CancelOccurrenceModal.propTypes = {
  occurrence: PropTypes.shape({
    startDate: PropTypes.string,
    participantCount: PropTypes.number,
    waitingCount: PropTypes.number,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  busy: PropTypes.bool,
};

CancelOccurrenceModal.defaultProps = {
  occurrence: null,
  busy: false,
};

export default CancelOccurrenceModal;
